import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { useParams } from "react-router-dom";
import LoadingCircular from "../../../loader/LoadingCircular";
import { getAllData } from "../../../Utils/firebaseServices";
import { Table } from "react-bootstrap";

function Attendance() {
  const { id } = useParams();

  const [value, setValue] = useState(new Date());
  const [presentDates, setPresentDates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [viewMode, setViewMode] = useState("table");
  const [rawData, setRawData] = useState([]);
  const [userName, setUserName] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await getAllData("financeUserPortal", (users) => {
          let allPresentDates = [];
          let allEntries = [];

          users.forEach((user) => {
            if (user.id === id) {
              setUserName(user.name);
            }
          });

          users.forEach((user) => {
            if (user.id === id && Array.isArray(user.AttendanceRecords)) {
              user.AttendanceRecords.forEach((att) => {
                if (att.type === "present" && att.date) {
                  const dateStr = att.date.slice(0, 10);
                  allPresentDates.push(dateStr);
                  allEntries.push({
                    date: dateStr,
                    type: att.type,
                  });
                }
              });
            }
          });

          const uniqueDates = [...new Set(allPresentDates)];
          setPresentDates(uniqueDates);
          setRawData(allEntries);
        });
      } catch (error) {
        console.error("Error fetching attendance data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <LoadingCircular />;
  }

  return (
    <div className=" mt-4">
      <h5>Employee:- {userName} </h5>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5>Attendance</h5>
        <button
          className="btn btn-primary"
          onClick={() =>
            setViewMode(viewMode === "table" ? "calendar" : "table")
          }
        >
          Switch to {viewMode === "table" ? "Calendar" : "Table"}
        </button>
      </div>

      {viewMode === "table" ? (
        <div className="table-responsive">
          <Table className="table table-bordered ">
            <thead>
              <tr>
                <th
                  style={{
                    textAlign: "center",
                    backgroundColor: "black",
                    color: "white",
                  }}
                >
                  Sr.No
                </th>
                <th
                  style={{
                    textAlign: "center",
                    backgroundColor: "black",
                    color: "white",
                  }}
                >
                  Date
                </th>
                <th
                  style={{
                    textAlign: "center",
                    backgroundColor: "black",
                    color: "white",
                  }}
                >
                  Type
                </th>
              </tr>
            </thead>
            <tbody>
              {rawData.map((entry, index) => (
                <tr key={index}>
                  <td className="atterndanceEmp">{index + 1}</td>
                  <td className="atterndanceEmp">{entry.date}</td>
                  {/* Fixed typo: entry.Date → entry.date */}
                  <td className="atterndanceEmp">{entry.type}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      ) : (
        <div className="attendance-calendar">
          <Calendar
            onChange={setValue}
            value={value}
            tileClassName={({ date, view }) => {
              if (view !== "month") return null;

              const dateStr = date.toLocaleDateString("en-CA");
              return presentDates.includes(dateStr) ? "present" : null;
            }}
            tileDisabled={({ date, view }) => {
              if (view !== "month") return true; // disable everything outside month view

              return !presentDates.includes(date); // disable all except present dates
            }}
            className="border shadow rounded calender container "
          />
        </div>
      )}
    </div>
  );
}

export default Attendance;
